import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {AiCallout} from 'shells/ai-callout/ai-callout';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

export const ChatCardCallout = () => {
    return (
        <AiCallout
            content={
                <Body size='small'>
                    <span>Nutshell’s chat feature uses a smart chatbot that learns from your </span>
                    <span className='underline'>
                        <Link
                            // @ts-expect-error
                            as={RoutedLink}
                            to='/inbox/settings/chat/knowledge'
                            isBold={true}
                            size='small'
                        >
                            Knowledge
                        </Link>
                    </span>
                    <span> content and engages with visitors based on the rules defined in </span>
                    <span className='underline'>
                        <Link
                            // @ts-expect-error
                            as={RoutedLink}
                            to='/inbox/settings/chat/chatbot-behavior'
                            isBold={true}
                            size='small'
                        >
                            Chatbot behavior
                        </Link>
                    </span>
                </Body>
            }
        />
    );
};
